import React, { useEffect, useState } from 'react';
import { connect } from "react-redux";
import { Grid } from "@material-ui/core";
import Header from "../../components/Header";
import SignUp from "../../components/SignUp";
import {parentContainer} from "../../config/theme";

const RegisterParent = React.memo((props) => {
  const [channelCode, setChannelCode] = useState('');
  const [viaChannel, setViaChannel] = useState(false);
  const [becomeChef, setBecomeChef] = useState(false);

  useEffect(() => {
    const { location } = props;
    if (!!location && !!location.search) {
      const indexAmp = location.search.indexOf('&');
      if (indexAmp < 0) {
        const index = location.search.indexOf('campaign=');
        if  (index > -1) {
          let searchString = location.search;
          searchString = searchString.substring(1);
          if (searchString.indexOf('=') === 8) {
            const campArr = searchString.split('=');
            if (campArr.length == 2) {
              if (campArr[0] === 'campaign') {
                const channelCode = campArr[1];
                setChannelCode(channelCode);
              }
            } // end-if campArr length 2
          } // end-if searchString indexOf = 8
        }// end-if index > -1
      } else {
        let searchString = location.search;
        searchString = searchString.substring(1);
        const paramsArr = searchString.split('&');
        const stateToUpdate = {};

        if (paramsArr.length > 1) {
          const campaignIndex = paramsArr[0].indexOf('campaign');
          const signupIndex = paramsArr[1].indexOf('signup');

          if (campaignIndex > -1) {
            const campaignStr = paramsArr[0];

            if (campaignStr.indexOf('=') === 8) {
              const campArr = campaignStr.split('=');
              if (campArr[0] === 'campaign') {
                const channelCode = campArr[1];
                setChannelCode(channelCode);
              } // end-if campArr 2
            } // end-if campStr.indexOf
          } // end-if campaignIndex

          if (signupIndex > -1) {
            const signupStr = paramsArr[1];

            if (signupStr.indexOf('=') === 6) {
              const signupArr = signupStr.split('=');
              if (signupArr[0] === 'signup') {
                const signupVal = signupArr[1];
                if (signupVal === 'channel') {
                  setViaChannel(true);
                }
              } // end-if signupArr 2
            } // end-if signupStr.indexOf
          } // end-if signupIndex
        } // end-if params length > 1
      }
    }

    if (!!location && !!location.state) {
      const { type } = location.state;
      if (type && type.indexOf('chef') > -1) {
        setBecomeChef(true);
      }
    }
  }, [props.location]);

  return (
    <div style={parentContainer}>
      <Grid container>
        <Header history={props.history} />
        <Grid container alignItems={"center"} justify={"center"} alignContent={"center"}>
          <SignUp history={props.history} location={{ campaign: channelCode, viaChannel, becomeChef }} />
        </Grid>
      </Grid>
    </div>
  );
});

const mapStateToProps = state => {
  return {
    userId: state.auth.userId
  };
};

const RegisterPage = connect(mapStateToProps)(RegisterParent);

export default RegisterPage;
